import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Card, Tab, Tabs } from "@mui/material";
import { buildTabPath, getActiveTabFromPath, LIBRARY_TAB } from "./documentLibraryTabs";
import LibraryTab from "./LibraryTab";
import SentDocumentsTab from "./SentDocumentsTab";

/** A college's document library: folder tree, file table, search, see DocumentLibrary/*.js. */
const DocumentLibrary = () => {
  const { universityId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const activeTab = getActiveTabFromPath(location.pathname);

  return (
    <Card sx={{ p: 2 }}>
      <Tabs
        value={activeTab}
        onChange={(_, nextTab) => navigate(buildTabPath(universityId, nextTab))}
        sx={{ mb: 2 }}
      >
        <Tab label="Library" />
        <Tab label="Sent documents" />
      </Tabs>

      {activeTab === LIBRARY_TAB ? (
        <LibraryTab universityId={universityId} />
      ) : (
        <SentDocumentsTab universityId={universityId} />
      )}
    </Card>
  );
};

export default DocumentLibrary;
